import React from "react";
import { motion, useAnimation } from 'framer-motion';
import SVGJSContainer, { staggerChildren, staggerChildrenList, textVariants } from '../../../utils/SVGJSContainer';

function Promouvoir1() {
  const controls = useAnimation();

  return (
    <SVGJSContainer controls={ controls }	>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="782.5"
        height="750"
        viewBox="0 0 782.5 750"
      >
        <g
          data-name="Groupe 2566"
          transform="translate(-196.223 -571.019)"
        >
          <path
            fill="#e1ea65"
            d="M0 0H750V750H0z"
            data-name="Rectangle 2269"
            transform="translate(196.223 571.019)"
          ></path>
          <motion.g
            data-name="Groupe 2565"
            fontFamily="AcuminPro-Bold, Acumin Pro"
            fontSize="30"
            fontWeight="700"
            variants={ textVariants }
            initial="hidden"
            animate={ controls }
          >
            <text data-name="5 000" transform="translate(351.223 1146.519)">
              <tspan x="0" y="22">
                5 000
              </tspan>
            </text>
            <text data-name="10 000" transform="translate(351.223 1044.519)">
              <tspan x="0" y="22">
                10 000
              </tspan>
            </text>
            <text data-name="15 000" transform="translate(351.223 945.519)">
              <tspan x="0" y="22">
                15 000
              </tspan>
            </text>
            <text data-name="20 000" transform="translate(351.223 847.519)">
              <tspan x="0" y="22">
                20 000
              </tspan>
            </text>
            <text data-name="25 000" transform="translate(351.223 741.519)">
              <tspan x="0" y="22">
                25 000
              </tspan>
            </text>
            <text data-name="30 000" transform="translate(351.223 646.519)">
              <tspan x="0" y="22">
                30 000
              </tspan>
            </text>
          </motion.g>
          <motion.g fill="none" data-name="Groupe 2563"
            variants={ textVariants }
            initial="hidden"
            animate={ controls }
          >
            <path
              stroke="#fff"
              strokeWidth="5"
              d="M0 0L586 0"
              data-name="Ligne 680"
              transform="translate(285.723 1261.519)"
            ></path>
            <path
              stroke="#000"
              strokeWidth="2"
              d="M0 0L485 0"
              data-name="Ligne 681"
              transform="translate(493.723 696.519)"
            ></path>
          </motion.g>
          <motion.g
            data-name="Groupe 2564"
            variants={ staggerChildren }
            initial="hidden"
					  animate={ controls }
          >
            <motion.g data-name="Rectangle 2251" transform="translate(493.723 1167.445)" variants={staggerChildrenList}>
              <path
                fill="none"
                d="M0 0H146V86.732H0z"
                data-name="Rectangle 2258"
                transform="translate(.5 .171)"
              ></path>
            </motion.g>
            <motion.g
              fill="#00849b"
              data-name="Rectangle 2252"
              transform="translate(493.723 1067.89)"
              variants={ staggerChildrenList }
            >
              <path d="M0 0H147V87.074H0z" data-name="Rectangle 2259"></path>
              <path
                d="M0 0H146V86.732H0z"
                data-name="Rectangle 2260"
                transform="translate(.5 .171)"
              ></path>
            </motion.g>
            <motion.g
              fill="#039db8"
              data-name="Rectangle 2253"
              transform="translate(493.723 968.335)"
              variants={ staggerChildrenList }
            >
              <path d="M0 0H147V87.074H0z" data-name="Rectangle 2261"></path>
              <path
                d="M0 0H146V86.732H0z"
                data-name="Rectangle 2262"
                transform="translate(.5 .171)"
              ></path>
            </motion.g>
            <motion.g
              fill="#4cbdd1"
              data-name="Rectangle 2254"
              transform="translate(493.723 868.78)"
              variants={ staggerChildrenList }
            >
              <path d="M0 0H147V87.074H0z" data-name="Rectangle 2263"></path>
              <path
                d="M0 0H146V86.732H0z"
                data-name="Rectangle 2264"
                transform="translate(.5 .171)"
              ></path>
            </motion.g>
            <motion.g
              fill="#76bdca"
              data-name="Rectangle 2255"
              transform="translate(493.723 769.226)"
              variants={ staggerChildrenList }
            >
              <path d="M0 0H147V87.074H0z" data-name="Rectangle 2265"></path>
              <path
                d="M0 0H146V86.732H0z"
                data-name="Rectangle 2266"
                transform="translate(.5 .171)"
              ></path>
            </motion.g>
            <motion.g
              fill="#a5c8cc"
              data-name="Rectangle 2256"
              transform="translate(493.723 708.776)"
              variants={ staggerChildrenList }
            >
              <path d="M0 0H147V47.968H0z" data-name="Rectangle 2267"></path>
              <path
                d="M0 0H146V47.626H0z"
                data-name="Rectangle 2268"
                transform="translate(.5 .171)"
              ></path>
            </motion.g>
            <motion.g
              fill="#a5c8cc"
              data-name="Rectangle 2256"
              transform="translate(493.723 671.519)"
              variants={ staggerChildrenList }
            >
              <path d="M0 0H147V14.226H0z" data-name="Rectangle 2267"></path>
              <path
                d="M0 0H146V13.884H0z"
                data-name="Rectangle 2268"
                transform="translate(.5 .171)"
              ></path>
            </motion.g>
          </motion.g>
          <path id="Tracé_30529" data-name="Tracé 30529" d="M551.606,1372.226v2.9c0,38.013,33.076,69.115,73.5,69.115h0c40.425,0,73.5-31.1,73.5-69.115v-1.9Z" transform="translate(-57.883 -205.537)" fill="#00758d" stroke="rgba(0,0,0,0)" stroke-width="1"/>
        </g>

      </svg>
    </SVGJSContainer>
  );
}

export default Promouvoir1;
